module.exports = __webpack_public_path__ + "img/bg-dots-1.0aadf2e2.svg";